import React, { useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';

const ProjectHelpCard = ({ onContactSupport }) => {
  const { theme } = useTheme();
  const [showTooltip, setShowTooltip] = useState(false);
  
  const handleContactSupport = () => {
    if (onContactSupport) {
      onContactSupport();
    } else {
      // Número de suporte do arquivo de ambiente
      const numeroSuporte = process.env.NUMERO_SUPORTE || '+555196929714';
      
      // Mensagem padrão para o WhatsApp
      const mensagem = encodeURIComponent('Olá! Preciso de ajuda com meu projeto. Pode me ajudar?');
      
      // URL do WhatsApp Web
      const whatsappUrl = `https://wa.me/${numeroSuporte.replace(/\D/g, '')}?text=${mensagem}`;
      
      // Abrir WhatsApp em nova aba
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const floatingButtonStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: theme.primaryGradient || '#1890ff',
    border: 'none',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: '#fff',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    transform: showTooltip ? 'scale(1.1)' : 'scale(1)',
  };

  const tooltipStyle = {
    position: 'fixed',
    bottom: '90px',
    right: '24px',
    backgroundColor: '#fff',
    color: '#333',
    padding: '12px 16px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '14px',
    fontWeight: '500',
    maxWidth: '280px',
    zIndex: 999,
    opacity: showTooltip ? 1 : 0,
    visibility: showTooltip ? 'visible' : 'hidden',
    transform: showTooltip ? 'translateY(0)' : 'translateY(10px)',
    transition: 'all 0.3s ease',
    border: `1px solid ${theme.primary || '#1890ff'}`,
  };

  const tooltipArrowStyle = {
    position: 'absolute',
    bottom: '-6px',
    right: '20px',
    width: '12px',
    height: '12px',
    backgroundColor: '#fff',
    border: `1px solid ${theme.primary || '#1890ff'}`,
    borderTop: 'none',
    borderLeft: 'none',
    transform: 'rotate(45deg)',
  };

  return (
    <>
      {/* Tooltip */}
      <div style={tooltipStyle}>
        <div style={tooltipArrowStyle}></div>
        <div>
          <strong>Precisa de Ajuda?</strong>
          <br />
          Nossa equipe está pronta para ajudar você a configurar seu projeto. <br /> Clique para acessar nosso suporte via Whatsapp.
        </div>
      </div>

      {/* Botão Flutuante */}
      <button
        style={floatingButtonStyle}
        onClick={handleContactSupport}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title="Contatar Suporte"
      >
        <QuestionCircleOutlined />
      </button>
    </>
  );
};

export default ProjectHelpCard;